import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryTimelineAndDensity = (params: QueryParams, endpoint?: string) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['timelineAndDensity', params],
        queryFn: () => queryFn(params, endpoint),
    });
};

export interface QueryParams {
    filter: {
        filters: IFilter[];
    };
}

export interface IData {
    endDate: number;
    startDate: number;
    score: number;
    percentile: number;
    numOfTasksPerMonth: number;
    numOfDelayDrivers: number;
}

export interface IHeatMapPortfolioProjectResponse {
    id: string;
    data: IData[];
    baselineData: IData[];
    label: string;
    versionHashCode: number;
    completionPercent: number;
    spiCriticality: number;
    spiMilestone: number;
    preferredSpiMethod: string | null;
}

export interface QueryResponse {
    heatMapPortfolioProjectResponse: IHeatMapPortfolioProjectResponse[];
    info: IToolTip;
}
